import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Juridiction, City, Typologies } from './lawyerSnippet.types';
import {
  Tab,
  TabPanel,
  Tabs,
  TabLabel,
  TabList,
} from '../../../../../components/tabs/Tabs';
import { JuridictionTab } from './JuridictionTab';
import { TypologiesTab } from './TypologiesTab';
import { VilleTab } from './VilleTab';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { ResultsType } from '../../../../state/reducers/results.types';

type Props = {
  lawyer: NonNullable<ResultsType['snippets']['professional']>;
  source: string;
  juridictions: Array<Juridiction>;
  villes: Array<City>;
  typologies: Typologies | null;
};

export class LawyerSnippetTabs extends React.Component<Props> {
  static defaultProps = {
    typologies: null,
  };

  onSelect = (index: number, last: any, evt: Event) => {
    const { source } = this.props;
    const element = evt.target as HTMLDivElement;
    if (element) {
      doctrineAnalytics('SnippetTabClicked', {
        button: element.dataset.value,
        type: 'Lawyer',
        source,
        reportOriginalQueryKey: true,
      });
    }
  };

  render() {
    const { juridictions, villes, typologies } = this.props;
    return (
      <Tabs onSelect={this.onSelect}>
        <TabList>
          {juridictions.length > 0 && (
            <Tab>
              <TabLabel dataValue="juridictions">
                <FormattedMessage id="search/components/search-snippets/aside/lawyer/LawyerSnippetTabs.tsx/1" />
              </TabLabel>
            </Tab>
          )}
          {villes.length > 0 && (
            <Tab>
              <TabLabel dataValue="villes">
                <FormattedMessage id="search/components/search-snippets/aside/lawyer/LawyerSnippetTabs.tsx/2" />
              </TabLabel>
            </Tab>
          )}
          {typologies && (
            <Tab>
              <TabLabel dataValue="clients">
                <FormattedMessage id="search/components/search-snippets/aside/lawyer/LawyerSnippetTabs.tsx/3" />
              </TabLabel>
            </Tab>
          )}
        </TabList>
        {juridictions.length > 0 && (
          <TabPanel>
            <JuridictionTab
              juridictions={juridictions}
              url={this.props.lawyer.url}
              source={this.props.source}
              lawyerId={this.props.lawyer.lawyerId}
              lawyerName={this.props.lawyer.title}
            />
          </TabPanel>
        )}
        {villes.length > 0 && (
          <TabPanel>
            <VilleTab
              villes={villes}
              url={this.props.lawyer.url}
              source={this.props.source}
              lawyerId={this.props.lawyer.lawyerId}
              lawyerName={this.props.lawyer.title}
            />
          </TabPanel>
        )}
        {typologies && (
          <TabPanel>
            <TypologiesTab typologies={typologies} />
          </TabPanel>
        )}
      </Tabs>
    );
  }
}
